import React, { useCallback } from 'react';
import type { PaginatedVehicleType } from 'contracts/VehicleTypes';
import { SortableHeader, SortableHeadersGroup } from 'components/Shared';
import { SortingParams } from 'contracts/Common';
import * as S from './styles';

interface Props {
  vehicleTypes: PaginatedVehicleType[];
  onSort?: (sort: SortingParams) => void;
  currentSort: SortingParams;
}

interface ItemProps {
  vehicleType: PaginatedVehicleType;
}

export const TypesList: React.FC<Props> = ({
  vehicleTypes,
  onSort,
  currentSort,
}) => {
  const Item = useCallback(({ vehicleType }: ItemProps): JSX.Element => {
    const { id, name, blockedAt } = vehicleType;

    return (
      <S.ListItem>
        <S.Column>{id}</S.Column>
        <S.Column>{name}</S.Column>
        <S.Column>{blockedAt && <S.LockIcon />}</S.Column>
        <S.ActionsColumn>
          <S.LinkActionButton to={`/configuracoes/tipos-veiculos/${id}/editar`}>
            <S.EditIcon />
          </S.LinkActionButton>
        </S.ActionsColumn>
      </S.ListItem>
    );
  }, []);

  return (
    <S.List>
      <S.ListHeader>
        <SortableHeadersGroup onSort={onSort} currentSort={currentSort}>
          <SortableHeader column="id" label="ID" />
          <SortableHeader column="name" label="NOME" />
          <div></div>
        </SortableHeadersGroup>
      </S.ListHeader>
      {vehicleTypes.map((setup) => (
        <Item key={setup.id} vehicleType={setup} />
      ))}
    </S.List>
  );
};
